export {};
//# sourceMappingURL=data-source-interpret.js.map